module.exports = __webpack_public_path__ + "2eb5c3d9c24a12b2ef023d03741cbd14.png";